var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.role == 0
        ? _c("ErrorPage")
        : !_vm.isMetaMaskConnected
        ? _c("div", { staticClass: "metamask-not-connected" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v("MetaMask Not Connected"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "metamask-message" }, [
              _c("p", [
                _vm._v(
                  "Please connect your MetaMask wallet to check your airdrop eligibility."
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "metamask-prompt" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "connect-btn",
                    attrs: { loading: _vm.connectingMetaMask },
                    on: { click: _vm.handleConnectMetaMask },
                  },
                  [_vm._v("\n        Connect MetaMask\n      ")]
                ),
              ],
              1
            ),
          ])
        : !_vm.chainSupported
        ? _c("div", { staticClass: "ineligible-container" }, [
            _c("div", { staticClass: "title" }, [_vm._v("Wrong Network")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "ineligible-wallet" },
              [
                _c("div", { staticClass: "ineligible-title" }, [
                  _vm._v("Unsupported Network"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "ineligible-text" }, [
                  _vm._v(
                    "Please switch MetaMask to the correct TreasureNet network to continue."
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "switch-btn",
                    on: {
                      click: function ($event) {
                        return _vm.$emit("switch-network")
                      },
                    },
                  },
                  [_vm._v("Switch Network")]
                ),
              ],
              1
            ),
          ])
        : _vm.isRuntimeLoading
        ? _c("div", { staticClass: "ineligible-container" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v("Checking Airdrop Eligibility"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ineligible-wallet" }, [
              _c("div", { staticClass: "ineligible-title" }, [
                _vm._v("Loading Wallet State"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ineligible-text" }, [
                _vm._v(
                  "Please wait while we verify your eligibility and claim status."
                ),
              ]),
            ]),
          ])
        : _vm.hasRecords === false
        ? _c("div", { staticClass: "ineligible-container" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v("Check for UNIT Airdrop Eligibility"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "ineligible-wallet" },
              [
                _c("div", { staticClass: "ineligible-title" }, [
                  _vm._v("Ineligible Wallet"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "ineligible-text" }, [
                  _vm._v("This wallet is not eligible for the Airdrop."),
                ]),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "switch-btn",
                    on: { click: _vm.handleSwitchAccount },
                  },
                  [_vm._v("Switch Account to Check Airdrop Eligibility")]
                ),
              ],
              1
            ),
          ])
        : _vm.hasRecords && !_vm.hasAgreed
        ? _c("div", [
            _c("div", { staticClass: "title" }, [
              _vm._v("Please Review and Accept the Airdrop Terms"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "agreement-container" },
              [
                _c("div", { staticClass: "agreement-intro" }, [
                  _c("p", [
                    _vm._v(
                      "To proceed with claiming your airdrop, you must carefully review and accept the following terms and\n          conditions."
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "By accepting, you acknowledge that you have read, understood, and agreed to the terms outlined below."
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "agreement-checkbox" },
                  [
                    _c(
                      "el-checkbox",
                      {
                        model: {
                          value: _vm.termsAccepted,
                          callback: function ($$v) {
                            _vm.termsAccepted = $$v
                          },
                          expression: "termsAccepted",
                        },
                      },
                      [
                        _vm._v(
                          "I ACCEPT THE TERMS AND CONDITIONS OF THIS AIRDROP\n          "
                        ),
                        _c(
                          "a",
                          {
                            staticClass: "terms-link",
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.openTermsModal($event)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "TOKEN AIRDROP TERMS AND\n            CONDITIONS"
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.showCheckboxError
                      ? _c("div", { staticClass: "error-text" }, [
                          _vm._v(
                            "Please accept the terms and conditions to continue."
                          ),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "accept-btn",
                    attrs: {
                      disabled: !_vm.termsAccepted,
                      loading: _vm.agreementLoading,
                    },
                    on: { click: _vm.handleAcceptTerms },
                  },
                  [_vm._v("Accept and Continue")]
                ),
              ],
              1
            ),
          ])
        : _vm.hasRecords && _vm.hasAgreed && _vm.shouldShowClaimView
        ? _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "flex-direction": "column",
                "align-items": "center",
              },
            },
            [
              _c("div", { staticClass: "title" }, [_vm._v("Claim Airdrop")]),
              _vm._v(" "),
              _c("div", { staticClass: "des" }, [
                _vm._v("Please claim your airdrop"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "con" }, [
                _c(
                  "p",
                  { staticClass: "user" },
                  [
                    _c("img", {
                      attrs: {
                        src: require("../assets/images/user.png"),
                        alt: "",
                      },
                    }),
                    _vm._v(" "),
                    _c("account", { attrs: { value: _vm.currentAccount } }),
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.hasManualClaim && _vm.hasAutoClaim
                  ? _c("div", [
                      _c(
                        "div",
                        { staticClass: "title-card" },
                        [
                          _vm._v(
                            "\n          Auto Airdrop Amount:\n          "
                          ),
                          _c(
                            "soan",
                            { staticStyle: { "font-size": "0.28rem" } },
                            [
                              _c("BigNumber", {
                                attrs: { number: _vm.autoAmount },
                              }),
                              _vm._v(" UNIT\n          "),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "auto-airdrop-info" }, [
                        _c("p", [
                          _vm._v(
                            "Airdrop tokens will be sent directly to your wallet in the future."
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [_vm._v("Please check your wallet balance.")]),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasManualClaim || (!_vm.hasAutoClaim && !_vm.hasManualClaim)
                  ? _c("div", { staticClass: "con_box" }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                          },
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("../assets/images/icon.png"),
                              alt: "",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "num" },
                            [
                              _c("big-number", {
                                attrs: { number: _vm.amount },
                              }),
                              _c(
                                "span",
                                { staticStyle: { "margin-left": "0.1rem" } },
                                [_vm._v("UNIT")]
                              ),
                              _vm._v(" "),
                              _c("p", [_vm._v("Claimable")]),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                          },
                        },
                        [
                          _vm.flag
                            ? _c("div", { staticClass: "success" }, [
                                _c("img", {
                                  attrs: {
                                    src: require("../assets/images/success.png"),
                                    alt: "",
                                  },
                                }),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.flag && _vm.hasManualClaim
                            ? _c(
                                "el-button",
                                {
                                  staticClass: "btn",
                                  attrs: {
                                    loading: _vm.btnLoading,
                                    disabled: _vm.amount <= 0,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleClaim()
                                    },
                                  },
                                },
                                [_vm._v("claim")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasAutoClaim && _vm.hasManualClaim
                  ? _c(
                      "div",
                      {
                        staticClass: "auto-airdrop-info",
                        staticStyle: {
                          "margin-top": "20px",
                          "text-align": "left",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "title-card" },
                          [
                            _vm._v(
                              "\n          Auto Airdrop Amount:\n          "
                            ),
                            _c(
                              "soan",
                              { staticStyle: { "font-size": "0.28rem" } },
                              [
                                _c("BigNumber", {
                                  attrs: { number: _vm.autoAmount },
                                }),
                                _vm._v(" UNIT\n          "),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "auto-airdrop-info" }, [
                          _c("p", [
                            _vm._v(
                              "Airdrop tokens will be sent directly to your wallet in the future."
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("Please check your wallet balance."),
                          ]),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]
          )
        : _vm.hasRecords && _vm.hasAgreed
        ? _c("div", { staticClass: "ineligible-container" }, [
            _c("div", { staticClass: "title" }, [_vm._v("Airdrop Claimed")]),
            _vm._v(" "),
            _c("div", { staticClass: "ineligible-wallet" }, [
              _c("div", { staticClass: "ineligible-title" }, [
                _vm._v("No Claimable Balance"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ineligible-text" }, [
                _vm._v(
                  "This wallet currently has no claimable airdrop balance."
                ),
              ]),
            ]),
          ])
        : _c("div", { staticClass: "ineligible-container" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v("Unable to Load Airdrop State"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ineligible-wallet" }, [
              _c("div", { staticClass: "ineligible-title" }, [
                _vm._v("Wallet State Unavailable"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ineligible-text" }, [
                _vm._v(
                  "We could not verify your eligibility right now. Please refresh and try again."
                ),
              ]),
            ]),
          ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "terms-dialog",
          attrs: {
            title: "TOKEN AIRDROP TERMS AND CONDITIONS",
            visible: _vm.termsModalVisible,
            width: "70%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.termsModalVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "terms-content" }, [
            _c("p", [
              _vm._v(
                'THESE TOKEN AIRDROP TERMS AND CONDITIONS (the "Agreement") is a binding contract between [NAME OF HKCO], a\n        company incorporated under the laws of Hong Kong with offices located at [ADDRESS] ("HKCo") and you the\n        platform user ("You"), HKCo and You (each a "Party", collectively, the "Parties").'
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                'This Agreement provides for: (a) the terms and conditions that govern your receipt of the [DESCRIBE THE\n        TOKENS] (the "Tokens") in an airdrop of the Tokens conducted by HKCo, and it defines your rights and\n        obligations with respect to the Tokens; (b) the fact that HKCo created and minted the Tokens, which are a\n        native digital asset intended to interact with and enable use of the blockchain application known as [DESCRIBE\n        THE NETWORK] (the "Network"), which is governed by [DESCRIBE THE GOVERNANCE STRUCTURE OF THE NETWORK]; and (c)\n        the fact that HKCo is undertaking a private airdrop of Tokens, which is not advertised and is made available\n        to a limited number of persons or entities who are selected prior to the airdrop by way of this Agreement and\n        where the recipients of such airdrop desire to participate in the Network and in the governance of the Network\n        and run consensus nodes and staking, which requires that such recipients have Tokens.'
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "This Agreement incorporates the attached Exhibit A – General Terms and Conditions."
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                'THIS AGREEMENT TAKES EFFECT WHEN YOU CLICK THE "I ACCEPT THE TERMS AND CONDITIONS OF THIS AIRDROP" BUTTON\n        (and the date of that acceptance being the "Effective Date").'
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                'IF YOU CLICK ON THE "I ACCEPT THE TERMS AND CONDITIONS OF THIS AIRDROP" BUTTON, PLEASE ALSO COPY AND PASTE\n        THE CRYPTO WALLET ADDRESS WHERE APPLICABLE FOR YOUR USER WALLET (AS DEFINED BELOW).'
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                'BY CLICKING ON THE "I ACCEPT THE TERMS AND CONDITIONS OF THIS AIRDROP" BUTTON BELOW YOU: (A) ACKNOWLEDGE THAT\n        YOU HAVE READ AND UNDERSTAND THIS AGREEMENT; (B) REPRESENT AND WARRANT THAT YOU HAVE THE RIGHT, POWER, AND\n        AUTHORITY TO ENTER INTO THIS AGREEMENT AND, IF ENTERING INTO THIS AGREEMENT FOR AN ORGANIZATION, THAT YOU HAVE\n        THE LEGAL AUTHORITY TO BIND THAT ORGANIZATION; AND (C) ACCEPT THIS AGREEMENT AND AGREE THAT YOU ARE LEGALLY\n        BOUND BY ITS TERMS.'
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _c("strong", [
                _vm._v(
                  "A. I ACCEPT THE TERMS AND CONDITIONS OF THIS AIRDROP ☐"
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("p", [
              _c("strong", [
                _vm._v(
                  "B. YOU HEREBY IRREVOCABLY DIRECT HKCO TO PROCURE THE TRANSFER OF ALL OF THE TOKENS TO BE AIRDROPPED\n        TO YOU UNDER THIS AGREEMENT TO THE USER WALLET (AS DEFINED BELOW)."
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("p", [
              _c("strong", [
                _vm._v(
                  'C. YOUR CRYPTO WALLET ADDRESS (the "User Wallet"), which will be the crypto wallet that HKCo has\n        already been provided with.'
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("h3", [_vm._v("Exhibit A")]),
            _vm._v(" "),
            _c("h4", [_vm._v("General Terms and Conditions")]),
            _vm._v(" "),
            _c("ol", [
              _c("li", [
                _c("strong", [_vm._v("Interpretation.")]),
                _vm._v(
                  ' No provision of this Agreement will be construed against either Party by\n          virtue of that Party having drafted and prepared this Agreement. All headings are inserted for reference\n          only. The term "including" is not limiting, and means "including without limitation". The singular includes\n          the plural and vice-versa, unless the context otherwise requires.'
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _c("strong", [_vm._v("No Claim or Ownership Interest.")]),
                _vm._v(
                  " Except as otherwise expressly set forth herein, the Your\n          ownership of Tokens: (a) does not provide You with rights of any form with respect to HKCo or its revenues\n          or assets, including, without limitation, any voting, distribution, redemption, liquidation, proprietary\n          (including all forms of intellectual property) or other financial or legal rights; and (b) does not provide\n          You with any ownership, equity, or other interest in HKCo; provided, however, that You shall be entitled to\n          use the Tokens to participate in the governance of the Network on the same basis as Token holders generally.\n        "
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _c("strong", [_vm._v("Intellectual Property.")]),
                _vm._v(
                  " You acknowledge and agree that HKCo retains all right, title and\n          interest in all of HKCo's intellectual property contained in the Tokens, including, without limitation,\n          inventions, ideas, concepts, code, discoveries, processes, marks, methods, software, compositions, formulae,\n          techniques, information and data, whether or not patentable, copyrightable or protectable in trademark, and\n          any trademarks, copyright or patents based thereon. You agree not to use, reverse engineer, modify, or alter\n          any of HKCo's intellectual property for any reason without HKCo's prior written consent."
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _c("strong", [_vm._v("Your Representations and Warranties.")]),
                _vm._v(
                  " In connection with the airdrop of Tokens to You, You\n          hereby represent and warrant to HKCo that on the Effective Date:\n          "
                ),
                _c("ol", { attrs: { type: "a" } }, [
                  _c("li", [
                    _vm._v(
                      "You have all requisite power and authority to execute and deliver this Agreement, to accept the\n              airdrop of the Tokens, and to carry out and perform Your obligations under this Agreement. All action on\n              Your part required for the lawful execution and delivery of this Agreement and other agreements required\n              hereunder have been or will be effectively taken prior to the Effective Date. This Agreement has been\n              duly executed by You. This Agreement constitutes a legal, valid and binding obligation of Yours\n              enforceable against You in accordance with its terms, except that such enforceability may be limited by\n              applicable bankruptcy, insolvency, reorganization, moratorium and similar laws of general application\n              relating to or affecting creditors' rights generally and by equitable principles (regardless of whether\n              enforcement is sought in a proceeding in equity or at law)."
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "HKCo's dealings with You and others who may receive Tokens from HKCo need not be uniform, and, without\n              limiting the foregoing, HKCo shall be entitled, among other things, to enter into agreements with such\n              other recipients (and/or other persons) on terms different than those set forth herein."
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "You are acquiring the Tokens with the primary intention to use the Tokens, and You represent and\n              warrant that You have no current intent to resell the Tokens."
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "You are fully aware of the risks associated with owning and using Tokens, including the inherent risk\n              of the potential for Tokens, and/or the private keys to Tokens, to be lost, stolen, or hacked. By\n              acquiring Tokens, You expressly acknowledge and assume these risks."
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "You have sufficient understanding of technical matters relating to Tokens, the Network, digital asset\n              storage mechanisms (such as digital asset wallets), and blockchain technology, to understand how to\n              acquire, store, and use Tokens, and to appreciate the risks and implications of acquiring Tokens."
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "You acknowledge that HKCo has made no representations or warranties whatsoever regarding the Tokens\n              and their functionality, or the assets, business, financial condition or prospects of HKCo or the\n              Network."
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "You acknowledge that HKCo has made no representations or warranties whatsoever regarding the income\n              tax consequences regarding the receipt or ownership of the Tokens."
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      'The execution, delivery and performance of this Agreement will not result in: (i) any violation of, be\n              in conflict with or constitute a material default under, with or without the passage of time or the\n              giving of notice of: (A) any provision of Your organizational documents, if applicable; (B) any\n              provision of any judgment, decree or order to which You are a party, by which You are bound, or to which\n              any of Your assets are subject; (C) any agreement, obligation, duty or commitment to which You are a\n              party or by which You are bound; or (D) any laws, statutes, ordinances, rules, regulations, judgments,\n              injunctions, administrative interpretations, orders and decrees of any Governmental Authority, including\n              amendments thereto (collectively, "Laws"); or (ii) the creation of any lien, charge or encumbrance upon\n              any of Your assets. "Governmental Authority" shall mean any nation or government, any state or other\n              political subdivision thereof, any entity exercising legislative, executive, judicial or administrative\n              functions of or pertaining to government, including without limitation any government authority, agency,\n              department, board, commission or instrumentality and any court, tribunal or arbitrator(s) of competent\n              jurisdiction and any self-regulatory organization. For the avoidance of doubt, Governmental Authority\n              may include private bodies exercising quasi-governmental, regulatory or judicial-like functions to the\n              extent they relate to either Parties or the Tokens.'
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "You represent and warrant that HKCo has not advertised the airdrop of the Tokens to You."
                    ),
                  ]),
                ]),
                _vm._v(
                  "\n          The foregoing shall be continuing representations, warranties, and covenants given by You throughout the\n          Term of this Agreement and shall apply to You, as at and after the Effective Date of this Agreement.\n        "
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _c("strong", [_vm._v("Term.")]),
                _vm._v(
                  ' Subject to Section 6 below, the initial term (the "Initial Term") of this Agreement\n          will begin on the Effective Date and shall continue for a period of one (1) year, with automatic renewals\n          for successive one (1) year periods unless HKCo provides written notice of non-renewal to You at least 30\n          days prior to the end of the then current term. "Term" shall mean the Initial Term and any and all renewal\n          terms.'
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _c("strong", [_vm._v("Termination.")]),
                _vm._v(
                  " Either Party may terminate this Agreement: (i) in the event of a material\n          breach by a Party of this Agreement that is not cured within 10 days after written notice of such breach has\n          been given to such Party by the other Party; (ii) immediately upon notice in the event of a material breach\n          of any provision of this Agreement by the other Party that is not capable of being cured; or (iii)\n          immediately upon notice, if either Party becomes insolvent or seeks protection under any bankruptcy,\n          receivership, creditor's arrangement, or comparable proceeding."
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "The full terms and conditions continue in the complete agreement document."
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.termsModalVisible = false
                    },
                  },
                },
                [_vm._v("Close")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }